import fetcher from '../../utils/fetcher';

/**
 * @typedef {Object} Product
 *
 * @typedef {'full'|'horizontal_scroll'} LayoutModeType
 *
 * @typedef {Object} LayoutStyle
 * @property {LayoutModeType} desktop
 * @property {LayoutModeType} mobile
 *
 * @typedef {Object} RecommendProductResponse
 * @property {Product[]} products - Array of product objects
 * @property {LayoutStyle} layout_style - Layout configuration for different devices
 *
 * Fetch recommended products for a given product id.
 * @param {Object} params
 * @param {string[]} params.product_ids - products
 * @param {string} params.page_type - page type
 * @returns {Promise<RecommendProductResponse|null>} A promise that resolves to the API response containing components or null if the request fails.
 */
export const fetchRecommendProductListApi = async ({
  productIds,
  pageType,
}) => {
  return fetcher('/api/renders/related_products', {
    method: 'POST',
    body: JSON.stringify({
      product_ids: productIds,
      page_type: pageType,
    }),
  })
    .then(async (response) => {
      if (response.ok) {
        return response.json();
      }
      return null;
    })
    .catch((error) => {
      console.error('Failed to fetch related products:', error);
      return null;
    });
};
